import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-paketsuche-kraft',
  templateUrl: './app.paketsuche.kraft.html',
  styleUrls: ['./app.paketsuche.kraft.scss'],
})
export class AppPaketsucheKraft implements OnInit {


  @Input()
  vermittlernummer: string;

  sucheDisabled: boolean = true;

  constructor() {
  }


  ngOnInit(): void {
    //debugger;
  }


  private errorHandling(error) {
    console.log(error);
  }

  sucheMaklerpakete(): void {
    console.log("sucheMaklerpakete");
    //this.router.navigate(['/anzeigeMaklerpaketeKraft']);
  }


  validiereVermittlernummer(newValue: string) {
    console.log("Paketsuche - Eingabe: " + newValue); //TODO Potential error after update ngModelChange is now updated after value update not before
    this.vermittlernummer = newValue;
    console.log("this.vermittlernummer: " + this.vermittlernummer);
    if (this.vermittlernummer.length == 9) {
      this.sucheDisabled = false;
    }
    else {
      this.sucheDisabled = true;
    }
 }

}
